import React from 'react'

import TextField from 'material-ui/TextField'

class TeamMembersSearch extends React.Component {

  constructor(props) {
    super(props)
  }

  handleFilterChanged = (e) => {
    this.props.onFilterChanged(e.target.value)
  }

  render() {
    return (
      <TextField
        key="text-field"
        style={{ fontSize: 14, margin: 0, marginTop: 0, width: '100%' }}
        hintText="Search"
        value={this.props.filter}
        onChange={this.handleFilterChanged}
      />
    )
  }

}

export default TeamMembersSearch



// WEBPACK FOOTER //
// ./src/schedule/workers/TeamMembersSearch.js